<template>
  <div class="verification-form-question">
    <div class="verification-cdd-form__question">
      <span class="verification-cdd-form__question-msg">
        {{ questionMessage }}
      </span>
      <div
        v-if="hasSlot('default')"
        class="verification-cdd-form__question-info">
        <slot />
      </div>
      <div class="verification-cdd-form__question-actions">
        <radio-field
          class="verification-cdd-form__radio-no"
          v-model="input"
          @input="onChange"
          :cb-value="CB_VALUES.no"
          :disabled="disabled"
          :pep="radioPep"
        >
          {{ "verification-cdd-form.lbl-no" | globalize }}
        </radio-field>
        <radio-field
          class="verification-cdd-form__radio-yes"
          v-model="input"
          @input="onChange"
          :cb-value="CB_VALUES.yes"
          :disabled="disabled"
        >
          {{ "verification-cdd-form.lbl-yes" | globalize }}
        </radio-field>
      </div>
      <p
        v-if="errorMessage"
        class="verification-cdd-form__error-msg"
      >
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>

<script>
import RadioField from '@/vue/fields/RadioField'
import { Bus } from '@/js/helpers/event-bus'

const CB_VALUES = {
  yes: 'Yes',
  no: 'No',
}

export default {
  name: 'verification-form-question',
  components: { RadioField },
  props: {
    value: { type: [String, Number], default: undefined },
    errorMessage: { type: String, default: undefined },
    questionMessage: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isPep: { type: Boolean },
  },
  data () {
    return {
      CB_VALUES,
      input: this.value || '',
      radioPep: false,
    }
  },

  created () {
    Bus.on('checked', (value) => {
      if (this.isPep && value) {
        this.radioPep = true
      } else {
        this.radioPep = false
      }
    })
  },

  methods: {
    onChange () {
      this.$emit('input', this.input)
    },
    hasSlot (slot) {
      return !!this.$slots[slot]
    },
  },
}
</script>
